import { render, staticRenderFns } from "./NewImportedTweet.vue?vue&type=template&id=06f723e2&scoped=true&"
import script from "./NewImportedTweet.vue?vue&type=script&lang=js&"
export * from "./NewImportedTweet.vue?vue&type=script&lang=js&"
import style0 from "./NewImportedTweet.vue?vue&type=style&index=0&id=06f723e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f723e2",
  null
  
)

export default component.exports